import { instance } from ".";
import axios from "axios";

export const getRoomTypesList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/room-type"
  });
  return response;
};

export const getRoomType = id => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/room-type/${id}`
  });
  return response;
};

export const createRoomType = data => {
  const response = instance({
    method: "post",
    url: `/work/api/dict/room-type`,
    headers: {
      'Accept': 'application/json'
    },
    data
  });
  return response;
};

export const deleteRoomType = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/dict/room-type/${id}`
  });
  return response;
};

export const updateRoomType = (id, main) => {
  const data = {
    main: {
      ...main,
    }
  }

  const response = instance({
    method: "put",
    url: `/work/api/dict/room-type/${id}`,
    data
  });
  return response;
};

export default {
  getRoomTypesList,
  getRoomType,
  createRoomType,
  deleteRoomType,
  updateRoomType
};
